import ApiFaqCategory from 'types/api/FaqCategory';

import Model from 'models/Model';

export default class FaqCategory implements Model {
    id: string;
    name: string;
    slug: string;

    constructor(data: ApiFaqCategory) {
        this.id = data.id;
        this.name = data.name;
        this.slug = data.slug;
    }
}